<template>
  <b-card
    no-body
    class="card-payment"
  >
    <b-card-header>
      <b-card-title>Realiza una búsqueda</b-card-title>
      <b-card-title class="text-primary">
        <small>{{ resultSize }} resultado(s)</small>
      </b-card-title>
    </b-card-header>
    <b-card-body>
      <b-col cols="12">
        <b-input-group>
          <b-input-group-prepend is-text>
            <feather-icon icon="SearchIcon" />
          </b-input-group-prepend>
          <b-form-input
            v-model="fieldModelValue"
            placeholder="Busca por el nombre del plan de estudios de tu interés"
          />

          <transition name="fade">
            <b-input-group-append
              v-if="fieldModelValue !== ''"
              is-text
              class="cursor-pointer"
              @click="() => fieldModelValue = ''"
            >
              <feather-icon
                icon="XIcon"
                class="text-danger"
                size="20"
              />
            </b-input-group-append>
          </transition>
        </b-input-group>
      </b-col>
    </b-card-body>

  </b-card>
</template>

<script>
import {
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
} from 'bootstrap-vue'

export default {
  components: {
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
  },
  props: {
    resultSize: {
      type: [Number, null],
      default: 0,
    },
  },
  data() {
    return {
      search: '',
    }
  },
  computed: {
    fieldModelValue: {
      get() {
        return this.search
      },
      set(newValue) {
        this.search = newValue
        this.$emit('newSearch', newValue)
      },
    },
  },
}
</script>
